import { Component, Input, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { ViewDetailsTrackerService } from './../../../shared/_services/view-details-tracker-service.service';
import { SigninWithOtpComponent } from 'src/app/modules/auth/_components/signin-with-otp/signin-with-otp.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-similar-tender',
  templateUrl: './similar-tender.component.html',
  styleUrls: ['./similar-tender.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SimilarTenderComponent implements OnInit, OnDestroy {
  @Input() pageType: any;
  @Input() category: any;
  @Input() id: any;
  @Input() title: any;
  @Input() similarTenderData: Array<any> = [];

  @ViewChild(SigninWithOtpComponent) modal!: SigninWithOtpComponent;
  isLoggedIn: any;
  private userSubscription!: Subscription;
  numberOfItems: number = 1;
  isScroll: boolean = true;
  containerId: string = "slider-" + Math.random().toString(36).substr(2, 9);
  hideContainer = false;
  topPerformingContainer = 'top-performing-inner-container2';
  isLeftVisible: boolean = false;
  isRightVisible: boolean = true;

  baseUrl: any = environment.TENDER.BASE_URL;

  isMobile: boolean = true;
  similarTendersList: any[] = [];

  constructor(private sharedService: SharedService, private router: Router,
    private authService: AuthService,
    private viewDetailsTrackerService: ViewDetailsTrackerService
  ) {
    this.userSubscription = this.authService.user$.subscribe(user => {
      this.isLoggedIn = !!user;
    });
  }

  ngOnInit(): void { }

  navigate(link: string): void {
    if (this.isLoggedIn) {
      // Navigate and scroll to top
      this.router.navigateByUrl('/' + link).then(() => {
        window.scrollTo(0, 0);  // Scroll to top after navigation
      });
    } else {
      this.viewDetailsTrackerService.incrementClickCount();
      if (this.viewDetailsTrackerService.shouldPromptSignup()) {
        this.promptSignup();
      } else {
        // Navigate and scroll to top if the user is not prompted for signup
        this.router.navigateByUrl('/' + link).then(() => {
          window.scrollTo(0, 0);  // Scroll to top after navigation
        });
      }
    }
  }

  trackByTenderId(tender: any): number {
    return tender.id; // Replace `id` with the actual unique property of your tender
  }

  promptSignup(): void {
    // Trigger the login/signup flow here.
    this.openModalWithComponent('restrict');
    // alert('Please sign up to continue viewing more details.');
  }

  isModalvis: boolean = false;
  openModalWithComponent(type: any) {
    this.isModalvis = true;
    setTimeout(() => {
      if (this.modal) {
        this.modal.isVisible = true; // Open the modal
        if (type === 'restrict') {
          this.modal.userRestrict = true;
          this.modal.isDownloadDoc = false;
        } else {
          this.modal.isDownloadDoc = true; // Open the modal
        }
      }
    }, 0);
  }

  onSliderScroll(event: Event): void {
    const { isRightVisible, isLeftVisible } = this.sharedService.onScroll(event);
    this.isRightVisible = isRightVisible;
    this.isLeftVisible = isLeftVisible;
  }

  scrollSliderDiv(right?: any): void {
    this.sharedService.scrollDiv(this.containerId, this.numberOfItems, right);
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

}
